import { render, staticRenderFns } from "./ClientNotificationForm.vue?vue&type=template&id=45d0fa84&scoped=true&"
import script from "./ClientNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotificationForm.vue?vue&type=style&index=0&id=45d0fa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0fa84",
  null
  
)

export default component.exports